import { render } from "./DesktopsAndScreensModule.vue?vue&type=template&id=d500fcba&scoped=true"
import script from "./DesktopsAndScreensModule.vue?vue&type=script&lang=js"
export * from "./DesktopsAndScreensModule.vue?vue&type=script&lang=js"

import "./DesktopsAndScreensModule.vue?vue&type=style&index=0&id=d500fcba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d500fcba"

export default script